(function() {
    'use strict';

    angular
        .module('atheer.content')
        .controller('AnnouncementInsightOverviewController', AnnouncementInsightOverviewController)

    /* @ngInject */
    function AnnouncementInsightOverviewController($scope, $q, $state, $filter, content_type, id, Report, Experience, ParseLinks, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadingData = false;
        vm.contentModel = $scope.$parent.vm.contentModel;

        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.reOrder = reOrder;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.predicate = pagingParams.predicate;
        vm.transition = transition;
        vm.pageSize = paginationConstants.itemsPerPage;
        vm.illustartionEmptyScreenId = "insight_graph";

        function reOrder(order) {
            vm.predicate = order;
            vm.transition();
        };

        function transition() {
            vm.promise = Experience.getViews({
                    query: "object_id==" + id,
                    page: vm.page - 1,
                    size: paginationConstants.itemsPerPage,
                    user_info: true
                }).$promise;

            function sort() {
                var result = [getSortOrder()];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            vm.promise.then(function(data, headers) {
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
            });
        };

        function getSortOrder() {
            if (vm.predicate.startsWith('-')) {
                return vm.predicate.substr(1) + ',' + 'desc';
            } else {
                return vm.predicate + ',' + 'asc';
            }

        };

        vm.loadData = function() {
           vm.loadingData = true;
           Experience.getViews({
                    query: "object_id==" + id,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    user_info: true
                }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.viewData = data;
                vm.page = pagingParams.page;
                vm.loadingData = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.loadingData = false;
            }
        };

        vm.loadData();
    }
})();
